import React from 'react';
import CasosDetalleContent from './components/CasosDetalleContent';

const Panel = props => (
  <CasosDetalleContent {...props} />
);

export default Panel;